import { useEffect, useMemo, useState } from "react";
import {
  Row,
  Input,
  Table,
  Typography,
  Switch,
  Modal,
  notification,
  Col,
  Space,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  GlobalTableStyle,
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { ColumnsType } from "antd/es/table";
import {
  DeleteButton,
  PrimaryButton,
  ViewDetailsButton,
  RefreshButton,
} from "../../styled/Button.styled";
import CustomCard from "../../countCard/CustomCard";
import pageSize from "../../../constants/pageSize";
import constants from "../../../constants";
import {
  useGetAllCategoryQuery,
  useGetCategoryCountQuery,
  useDeleteCategoryByIdMutation,
  useUpdateCategoryStatusByIdMutation,
} from "../../../feature/Category/categoryApiSlice";
import { ICategory } from "../../../types/category";
import dummyFace from "../../../assets/dummyFace.png";
import VehicleExcelUpload from "./VehicleExcelUpload";
import { categoryRank } from "../../../utils/categoryOrder";
const defaultImage: string = require("../../../assets/logo/defaultImage.svg").default;

function Category() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading, isFetching,refetch } = useGetAllCategoryQuery();
  const [currentPage, setCurrentPage] = useState(1);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isExcelUploadModalOpen, setIsExcelUploadModalOpen] = useState(false);

  const { data: countData } = useGetCategoryCountQuery();
  // Sorted copy: RTK Query hands back frozen data, so sorting it in place would throw.
  const sortedCategories = useMemo(
    () =>
      [...(data?.data.content ?? [])].sort(
        (a, b) => categoryRank(a.name) - categoryRank(b.name)
      ),
    [data]
  );
  const { confirm } = Modal;

  const [nameValue, setNameValue] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [deleteCategoryById] = useDeleteCategoryByIdMutation();
  const [updateCategoryStatusById] = useUpdateCategoryStatusByIdMutation();
  const showConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Delete Category?",
      onOk() {
        onDelete(id);
      },
      onCancel() { },
    });
  };

  const onDelete = (id: number) => {
    deleteCategoryById(id)
      .unwrap()
      .then(() => {
        notification.success({
          message: "Sucessfully Deleted!",
          placement: "bottomLeft",
        });
      });
  };
  const toogleSwitch = (id: any) => {
    updateCategoryStatusById(id);
  };
  const columns: ColumnsType<ICategory> = [
    {
      key: "name",
      width: "30%",
      title: (
        <div>
          <Typography.Text> Name</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [nameValue],
      onFilter: (value: any, record) => {
        return record?.name?.toLowerCase().includes(value?.toLowerCase());
      },
      render: (value: any, record) => {
        return (
          <>
            <Row align={"middle"}>
              <Col span={6}>
                <img
                  alt="vehicle"
                  src={`${record.image}`}
              onError={(e) => {
                (e.target as HTMLSourceElement).src= defaultImage
             }}
                  style={{
                    height: "48px",
                    width: "48px",
                    borderRadius: "30px",
                  }}
                />
              </Col>
              <Col span={18}>{record.name}</Col>
            </Row>
          </>
        );
      },
      dataIndex: "name",
    },
    {
      key: "vehicle",
      width: "25%",
      title: (
        <div>
          <Typography.Text>Vehicle</Typography.Text>
          <Input.Search
            onChange={(e) => {
              setVehicle(e.target.value);
            }}
            placeholder="Search here"
          />
        </div>
      ),
      filteredValue: [vehicle],
      onFilter: (value: any, record) => {
        return record?.vehiclesCount
          ?.toString()
          .toLowerCase()
          .includes(value?.toLowerCase());
      },
      render: (_, record) => {
        return record?.vehiclesCount;
      },
      dataIndex: "vehiclesCount",
    },
    {
      key: "seatCapacity",
      width: "15%",
      title: (
        <div style={{ marginLeft: 40 }}>
          <Typography.Text>Seat</Typography.Text>
        </div>
      ),
      render: (_, record) => {
        return <div style={{ marginLeft: 40 }}>{record?.seatCapacity}</div>;
      },
      dataIndex: "seatCapacity",
    },
    {
      key: "",
      align: "right",
      title: (
        <div>
          <Typography.Text>Status</Typography.Text>
        </div>
      ),
      render: (_, record) => {
        return (
          <>
            {record.status === true ? (
              <>
                <div>
                  Active
                </div>
                <Switch
                  onChange={(e) => toogleSwitch(record.id)}
                  checked={record.status}
                  style={{ backgroundColor: "green" }}
                />
              </>
            ) : (
              <>
                <div>
                  Inactive
                </div>
                <Switch
                  onChange={() => toogleSwitch(record.id)}
                  checked={record.status}
                  style={{ backgroundColor: "red" }}
                />
              </>
            )}
          </>
        );
      },
    },
    {
      key: "viewDetails",
      align: "right",
      dataIndex: "viewDetails",
      render: (_, record) => (
        <ViewDetailsButton onClick={() => openPlaceDetails(record.id)}>
          View Details
        </ViewDetailsButton>
      ),
    },
    {
      key: "deleteButton",
      align: "right",
      width: "1%",
      render: (_, record) => (
        <DeleteButton onClick={() => showConfirm(record.id)} />
      ),
    },
  ];
  const openPlaceDetails = (id: number) => {
    navigate(`edit/${id}?page=${currentPage}`);
  };

  const sum = data?.data.content.length;
  const active = countData?.data.isActive;
  const inActive = countData?.data.inActive;
  
  useEffect(() => {
    refetch(); 
  }, [refetch]);

  useEffect(() => {
    // Restore page from URL when component mounts or when navigating back
    const urlParams = new URLSearchParams(location.search);
    const pageFromUrl = urlParams.get('page');
    if (pageFromUrl) {
      setCurrentPage(parseInt(pageFromUrl, 10));
    }
  }, [location.search]);

  return (
    <>
      <Row justify="space-between" className="button-bottom-margin">
        <CustomCard
          sum={sum}
          text="Categories"
          activeText="Active"
          active={active}
          inActiveText="Inactive"
          inActive={inActive}
        />
        <Space>
          <RefreshButton 
            loading={isRefreshing}
            onClick={async () => {
              setIsRefreshing(true);
              await refetch();
              setIsRefreshing(false);
            }} 
          />
          <Link to="add">
            <PrimaryButton> Add Category</PrimaryButton>
          </Link>
          <PrimaryButton 
            onClick={() => setIsExcelUploadModalOpen(true)}
          >
            Add/Update Vehicle
          </PrimaryButton>
        </Space>
      </Row>
      <LightBlueContainer>
        <WhiteContainer>
          <GlobalTableStyle>
            <Table<ICategory>
              loading={isLoading || isFetching}
              columns={columns}
              dataSource={sortedCategories}
              rowKey="id"
              pagination={{
                pageSize,
                current: currentPage,
                onChange: (page) => {
                  setCurrentPage(page);
                },
              }}
            />
          </GlobalTableStyle>
        </WhiteContainer>
      </LightBlueContainer>
      
      <Modal
        title="Upload Vehicle Excel"
        open={isExcelUploadModalOpen}
        onCancel={() => setIsExcelUploadModalOpen(false)}
        footer={null}
        width={500}
      >
        <VehicleExcelUpload onClose={() => setIsExcelUploadModalOpen(false)} />
      </Modal>
    </>
  );
}
export default Category;
